import styled from 'styled-components';
import { NavTitleStyled } from 'layouts/header/nav/navLink.styles';

export const NavHeadingWithButtonStyles = styled.div`
  ${({ theme: { colors, spacing } }) => `
    width: 100%;
    font-weight: bold;
    padding-bottom: ${spacing?.(0.5)};
    color: ${colors.grey?.darkest};
    box-shadow: inset 0px -1px 0px ${colors.grey?.light};
    align-items: center;
    display: flex;
    justify-content: space-between;
  `}

  p {
    min-height: 2.875rem; // Match the height of the DS Icon Button
    display: flex;
    align-items: center;
  }
`;

export const NavLinkStyled = styled(NavTitleStyled)`
  justify-content: space-between;
  align-items: stretch;
`;

export const CenteredText = styled.div`
  display: flex;
  align-items: center;
`;
